import Nav from "./../Page/Share/Nav/Nav";
const Post9 = () => {
  return (
    <div>
      <div className="container">
        <Nav></Nav>

        <div className="infowork">
          {/* items Title} */}
          <h2>
            Early Bird Brand Identity Design
          </h2>
          {/* items?.Description */}
          <p>
            Early Bird is a food restaureant.
          </p>
          {/* img section */}
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/18334952/media/2a8d49cd3f1579904ed5263124efe074.jpg" alt="" />
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/18525260/media/8f5b00a6ac956900483f548549b03dc0.jpg" alt="" />
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/18550051/media/5dfad30264372766402fc1253d84f5d2.jpg" alt="" />
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/19263195/media/f6d6dc8ae07e75c927183a2536d4400f.jpg" alt="" />
          <img src="https://cdn.dribbble.com/users/6827497/screenshots/19272721/media/ef6ab6505471b3fe7bebbb9d6ab0b46d.jpg" alt="" />

          <p>

          </p>
        </div>
      </div>
    </div>
  );
};

export default Post9;
